import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../../modules/Auth/_redux/authRedux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import * as crud from "./operations";
import { ClientEditModal, ClienDeleteModal } from "./editModal";
import { ActionsColumnFormatter } from "./buttonsActions";


import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import overlayFactory from 'react-bootstrap-table2-overlay';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import axios from "axios"
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { filterFactory, optionsFactory, FilterLayout } from "../../helper/table"
import ExcelExport from "../../helper/export-xlsx"
import PDFExport from "../../helper/export-pdf"
import { useToasts } from 'react-toast-notifications';

const { ExportCSVButton } = CSVExport;
function Wrapper(props) {
  const { addToast } = useToasts()
  const [queryng, setQuery] = useState(true)
  const [documents, setDocuments] = useState([]);
  const [edit_show, setEditShow] = useState(false);
  const [delete_show, setDeleteShow] = useState(false);

  const [filter, setFilter] = useState("");

  const [activeClient, setActiveClient] = useState({});
  useEffect(() => {
    let mounted = true
    crud.getClients((args) => {
      mounted && setDocuments(args);
      setQuery(false);
    });
    return function cleanup() {
      mounted = false
    }
  }, []);
  const modal = {
    controllers: props.controllers,
    show: edit_show,
    delete: delete_show,
    client: activeClient,
    handleClose: () => setEditShow(false),
    handleShow: () => setEditShow(true),
    hideDelete: () => setDeleteShow(!delete_show),

    handleDelete: (uid) => {
      crud
        .getClient(uid)
        .then((res) => {
          const client = res.data.payload;
          setActiveClient(client);
          setDeleteShow(true);
        })
        .catch(function (thrown) {
          if (axios.isCancel(thrown)) {
            console.log(`request cancelled:${thrown.message}`)
          } else {
            console.log('another error happened')
          }
        })
    },
    deleteClient: (uid) => {
      crud.deleteClient(uid).then(() => {
        crud.getClients(setDocuments);
        addToast(process.env["REACT_APP_DELETE"], { appearance: 'success' });


        setDeleteShow(!delete_show);
      }).catch(err => {
        addToast(process.env["REACT_APP_NO_DELETE"], { appearance: 'error' });
      })
    },
    update: (client) => {
      crud.updateClient(client).then(() => {
        crud.getClients(setDocuments);
        addToast(process.env[`REACT_APP_${(client.uid ? "update" : "create").toUpperCase()}`], { appearance: 'success' });

        setEditShow(!edit_show);
      }).catch(err => {
        addToast(process.env[`REACT_APP_${(client.uid ? "no_update" : "no_create").toUpperCase()}`], { appearance: 'error' });


      })
    },
    openEdit: (uid) => {
      if (uid) {
        crud
          .getClient(uid)
          .then((res) => {
            const client = res.data.payload;
            setActiveClient(client);
            setEditShow(!edit_show);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setActiveClient({});
        setEditShow(!edit_show);
      }
    },
  };

  if (!crud.columns.filter((col) => col.dataField === "action").length) {
    crud.columns.push({
      dataField: "action",
      text: "Actions",
      formatter: ActionsColumnFormatter,
      formatExtraData: modal,
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    });
  }
  const fields = ["name", "description"]
  const data = filterFactory(documents, filter, fields)
  const options = optionsFactory(data)
  return (
    <ToolkitProvider
      keyField="uid"
      data={data}
      columns={[{
        dataField: "no",
        text: "NO",
        sort: true,
        headerStyle: {
          width: "80px"
        },
        formatter: (c, r, i) => i + 1
      }, ...crud.columns]}
      exportCSV={true}
    >
      {
        toolkit => (
          <>
            <div
              className="content d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div
                className="subheader py-4 py-lg-4 subheader-solid"
                id="kt_subheader"
              >
                <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                  <div className="d-flex align-items-center flex-wrap mr-2">
                    <h5 className="text-dark font-weight-bold mt-2 mb-2 mr-5">
                      Payments
              </h5>
                    <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-5 bg-gray-200"></div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div
                      /* href="#" */
                      className="btn btn-light btn-sm font-weight-bold"
                      id="kt_dashboard_daterangepicker"
                      data-toggle="tooltip"
                      title="Select dashboard daterange"
                      data-placement="left"
                    >
                      <span
                        className="text-muted font-weight-bold mr-2"
                        id="kt_dashboard_daterangepicker_title"
                      >
                        Today
                </span>
                      <span
                        className="text-primary font-weight-bold"
                        id="kt_dashboard_daterangepicker_date"
                      >
                        {new Date().toDateString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card card-custom gutter-b">
                <div className="card-header d-flex justify-content-between">
                  <h5 className="mt-7 card-label">Payments List</h5>
                  <div className="card-toolbar">
                    <div className="card mx-2">
                      <div className="card-toolbar">
                        <span className="svg-icon svg-icon-md  mx-2">
                          <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")}
                          />
                        </span>
                        <ExportCSVButton
                          {...toolkit.csvProps}
                          className="btn btn-info font-weight-bolder mx-1"
                        >
                          .CSV
                    </ExportCSVButton>
                        <PDFExport columns={fields} data={data} name="Payments">
                          <button className="btn btn-danger font-weight-bolder mx-1">
                            .PDF
                          </button>
                        </PDFExport>
                        <ExcelExport columns={fields} data={data} name="Payments">
                          <div className="btn btn-success font-weight-bolder mx-2">
                            .XLS
                          </div>
                        </ExcelExport>
                      </div>
                    </div>

                    <div
                      /* href="#" */
                      className="btn btn-primary font-weight-bolder"
                      onClick={() => {
                        modal.openEdit();
                      }}
                    >
                      <span className="svg-icon svg-icon-md">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Design/Flatten.svg")}
                        />
                      </span>
                New Payment
              </div>
                  </div>
                </div>

                <div className="card-body">
                  <FilterLayout controller={setFilter} />
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center  "
                    bootstrap4
                    hover
                    keyField="uid"
                    {...toolkit.baseProps}
                    loading={queryng}
                    pagination={paginationFactory(options)}
                    overlay={overlayFactory({ spinner: true })}
                    noDataIndication={<div className="mr-2 text-muted">No records found</div>}
                  ></BootstrapTable>
                </div>
              </div>
            </div>
            <ClientEditModal {...modal} />
            <ClienDeleteModal {...modal} />
          </>
        )
      }
    </ToolkitProvider>
  );
}
export default injectIntl(connect(null, auth.actions)(Wrapper));
